import { render } from "./AppLayout.vue?vue&type=template&id=0cbdd3ac&bindings={}"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0cbdd3ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cbdd3ac')) {
    api.reload('0cbdd3ac', script)
  }
  
  module.hot.accept("./AppLayout.vue?vue&type=template&id=0cbdd3ac&bindings={}", () => {
    api.rerender('0cbdd3ac', render)
  })

}

script.__file = "resources/js/Pages/Layouts/AppLayout.vue"

export default script